module.exports = __webpack_public_path__ + "2bd5dbd9a817a0584981d8a01e4d0aa5.svg";